module.exports = ".w-print {\n  width: 65% !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/charts/chart-bar/chart-bar.component.scss
// module id = ./src/app/components/tools/charts/chart-bar/chart-bar.component.scss
// module chunks = main